import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

class Ownership extends AppRecord {
  get person(){
    return this.constructor.employeeStore.peopleById.get(this.person_id)
  }
  get person_name(){
    if(this.person){
      return this.person.name
    } else {
      return undefined
    }
  }
  get person_type(){
    if(this.person){
      return this.person.translated_type
    } else {
      return undefined
    }
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get entity_name(){
    if(this.entity){
      return this.entity.name
    } else {
      return undefined
    }
  }
  get entity_long_name(){
    if(this.entity){
      return this.entity.long_name
    } else {
      return undefined
    }
  }
}

export default Ownership
